import z from "zod";
import { AuditedEntitySchema } from "../common";

const ProjectDistancesSchema = AuditedEntitySchema.extend({
  distanceId: z.uuidv7(),
  projectId: z.uuidv7(),
  distance: z.int().min(0),
});

export const ProjectDistanceSchemas = {
  create: ProjectDistancesSchema.omit({ createdAt: true, updatedAt: true }),

  update: ProjectDistancesSchema.omit({ createdAt: true, updatedAt: true }),

  delete: ProjectDistancesSchema.omit({
    createdAt: true,
    updatedAt: true,
    distance: true,
  }),

  findById: z.object({ id: z.uuidv7() }),

  importEntity: ProjectDistancesSchema.omit({ createdAt: true, updatedAt: true }),

  export: ProjectDistancesSchema.omit({ createdAt: true, updatedAt: true }).array(),
};
